module.exports = __webpack_public_path__ + "assets/d00f8401b39b6d0ea062ed9ad39dc2c5.png";